import { Form, Input } from 'antd';

import { requiredRule } from 'app/utils/rules';

import { HeaderWrapper } from '../../../../HeaderWrapper/HeaderWrapper';
import { ActionContainer } from '../ActionContainer/ActionContainer';

import './LinkRedirectionForm.scss';

type Props = {
  fieldName: string | number;
};

export const LinkRedirectionForm = ({ fieldName }: Props) => {
  return (
    <ActionContainer fieldName={fieldName}>
      <HeaderWrapper title="Links" gapTitleChildren={16}>
        <div className="linkRedirectionForm">
          <HeaderWrapper isBold={false} title="Web link">
            <Form.Item name={[fieldName, 'webLink']} rules={[requiredRule]}>
              <Input placeholder="Paste link here" />
            </Form.Item>
          </HeaderWrapper>
          <HeaderWrapper isBold={false} title="App link">
            <Form.Item name={[fieldName, 'appLink']} rules={[requiredRule]}>
              <Input placeholder="Paste link here" />
            </Form.Item>
          </HeaderWrapper>
        </div>
      </HeaderWrapper>
    </ActionContainer>
  );
};
